const getEngagementsListUrl = '/crm/engagements/';

export default getEngagementsListUrl;
